import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB1H: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="h) vliv odstranění stavby na okolní stavby a pozemky"
      subtitle="včetně dopadů na přístupnost, ochrana okolí, vliv odstranění stavby na odtokové poměry, vliv odstranění stavby na požární bezpečnost okolních staveb a pozemků"
      sectionKey="b1h"
    >
      <>
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1h.hasImpactOnSurroundings"
            label="Vliv na okolní stavby a pozemky"
          />
        </div>
        {formik?.values.b1h?.hasImpactOnSurroundings && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1h.impactOnSurroundings"
              label=""
              component={RichTextInput}
              aiHint={
                'Vliv odstranění stavby na okolní stavby a pozemky, včetně dopadů na přístupnost'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1h.hasSurroundingProtection"
            label="Ochrana okolí"
          />
        </div>
        {formik?.values.b1h?.hasSurroundingProtection && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1h.surroundingProtection"
              label=""
              component={RichTextInput}
              aiHint={
                'Ochrana okolí při odstraňování stavby'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1h.hasDrainageImpact"
            label="Vliv na odtokové poměry"
          />
        </div>
        {formik?.values.b1h?.hasDrainageImpact && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1h.drainageImpact"
              label=""
              component={RichTextInput}
              aiHint={
                'Vliv odstranění stavby na odtokové poměry'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1h.hasFireSafetyImpact"
            label="Vliv na požární bezpečnost"
          />
        </div>
        {formik?.values.b1h?.hasFireSafetyImpact && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1h.fireSafetyImpact"
              label=""
              component={RichTextInput}
              aiHint={
                'Vliv odstranění stavby na požární bezpečnost okolních staveb a pozemků'
              }
            />
          </div>
        )}
      </>
    </FormSectionTwoColumns>
  )
}
